import {Drawer} from 'antd'
import useTranslate from 'modules/local/useTranslate'
import React, {useRef, useState} from 'react'
import _ from "lodash"

export const DrawerBottomMenu = ({
                                     placement = 'bottom',
                                     title = '',
                                     isToggle,
                                     toggle,
                                     children,
                                     ...props
                                 }) => {
    const t = useTranslate()
    const [height, setHeight] = useState('auto')
    const [dragY, setDragY] = useState(0)          // độ lệch khi đang kéo
    const [isDismissing, setIsDismissing] = useState(false)

    // Touch tracking refs
    const touchStartY = useRef(null)
    const touchStartTime = useRef(null)

    const onToggleHeight = () => {
        if (height === 'auto') {
            setHeight('80Vh')
        } else {
            setHeight('auto')
        }
    }

    const onClose = () => {
        toggle(false)
    }

    // ── Dismiss với animation ────────────────────────────────────
    const dismissWithAnimation = () => {
        setIsDismissing(true)
        // Đợi animation xong rồi mới close thật
        setTimeout(() => {
            setIsDismissing(false)
            setDragY(0)
            onClose()
        }, 300)
    }
    // ────────────────────────────────────────────────────────────

    const handleTouchStart = (e) => {
        touchStartY.current = e.touches[0].clientY
        touchStartTime.current = Date.now()
        setDragY(0)
    }

    const handleTouchMove = (e) => {
        if (touchStartY.current === null) return;
        const deltaY = e.touches[0].clientY - touchStartY.current
        // Chỉ cho kéo xuống, không cho kéo lên
        if (deltaY > 0) setDragY(deltaY)
    }

    const handleTouchEnd = (e) => {
        if (touchStartY.current === null) return;

        const deltaY = e.changedTouches[0].clientY - touchStartY.current
        const deltaTime = Date.now() - touchStartTime.current
        const velocity = deltaY / deltaTime

        const SWIPE_THRESHOLD = 80
        const VELOCITY_THRESHOLD = 0.4

        if (deltaY > SWIPE_THRESHOLD || velocity > VELOCITY_THRESHOLD) {
            dismissWithAnimation()
        } else {
            // Snap về vị trí cũ
            setDragY(0)
        }

        touchStartY.current = null
    }

    // Style áp lên wrapper bên trong drawer
    const drawerContentStyle = {
        transform: isDismissing
            ? 'translateY(100%)'           // animation tắt: trượt xuống hết
            : `translateY(${dragY}px)`,    // đang kéo: theo ngón tay
        transition: isDismissing
            ? 'transform 0.3s cubic-bezier(0.32, 0, 0.67, 0)'   // ease-out nhanh
            : dragY === 0
                ? 'transform 0.2s ease'    // snap về
                : 'none',                  // đang kéo: không có transition
        willChange: 'transform',
    }

    return (
        <Drawer
            className="text-xl font-medium prefix-drawer-dialog rounded-t-2xl"
            styles={{
                body: {
                    padding: '0px',
                    marginLeft: '0px',
                    marginRight: '0px',
                },
                content: {
                    minHeight: '60vh',
                    maxHeight: '77vh',
                    overflowY: 'auto',
                    // Ẩn overflow để không thấy content bị kéo ra ngoài
                    overflow: 'hidden',
                    ...drawerContentStyle
                }
            }}
            placement={placement}
            closable={false}
            onClose={onClose}
            open={isToggle}
            key={placement}
            height={height}
            title={
                <div className="flex flex-center">
                    <div
                        style={{
                            touchAction: 'none',
                            width: '30%',
                            height: 6,
                            background: '#d1d5db',
                            padding: '3px 0',
                        }}
                        className="rounded-full cursor-grab"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onClick={onToggleHeight}
                    />
                    {title && title}
                </div>
            }
            footer={
                <div
                    onClick={onClose}
                    className="flex flex-center font-bold text-color-300 text-xs uppercase tracking-wider py-2">
                    {t('close')}
                </div>
            }>
            {_.isFunction(children) ? children(isToggle, toggle) : children}
        </Drawer>
    )
}

export default DrawerBottomMenu
